import { useMutation } from '@apollo/client';
import { APPROVE_WELD } from '@bechtel/client-gql';
import { ApproveWeldPayload, Scalars } from '@bechtel/types';

export function useApproveWeld(
  onCompleted: (data) => void,
  onError: (error) => void,
  refetchQueries: string[]
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ approveWeld: ApproveWeldPayload }, { commodityMilestoneId: Scalars['ID'] }> {
  const response = useMutation<{ approveWeldPayload: ApproveWeldPayload }, { commodityMilestoneId: Scalars['ID'] }>(
    APPROVE_WELD,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        if (onCompleted) onCompleted(data);
      },
      onError: (error) => {
        if (onError) onError(error);
      },
      refetchQueries: refetchQueries,
    }
  );
  return response;
}
